export const getQueryParam = (url, key) => {
  const params = new URLSearchParams(url);
  return params.get(key)
}